<template>
    <div class="container">
        <el-form ref="form" :model="searchFormData" >
          <el-row type="flex" class="row-bg" justify="space-around">

            <el-col :span="6">
              <el-form-item label="">
                <el-input  placeholder="输入名称搜索" v-model="searchFormData.keyword" clearable=""></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-button type="primary" @click="search">搜索</el-button>
            </el-col>

            <el-col :span="6" :offset="6" style="text-align:right">
              <el-button type="primary" @click="add">添加地址</el-button>
            </el-col>
          </el-row>
        </el-form>


        <el-table
          ref="table"
          v-loading="searchLoading"
          :data="pageProps.records"
          element-loading-text="正在查询"
          fit
          stripe
          highlight-current-row
        >
        <el-table-column align="center" label="项目" prop="project.name"> </el-table-column>
        <el-table-column align="center" label="店铺名称" prop="shop_name"> </el-table-column>

          <el-table-column align="center" label="所在地区" prop="adname"> </el-table-column>
          <el-table-column align="center" label="详细地址"  prop="address"/>
       
          <el-table-column label="操作" fixed="right" align="center" class-name="small-padding fixed-width" width="200">
            <template slot-scope="{row}">
            
              <el-button  type="primary" size="mini" @click="edit(row.u_address_id)">
                编辑
              </el-button>

              <el-button  type="warning" size="mini" @click="del(row)">
                删除
              </el-button>

            </template>
          </el-table-column>
      </el-table>
      <div style="text-align:center;padding:20px">
        <!--分页-->
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageProps.total"
          :page-size="pageProps.pageSize"
          :page-sizes="[5, 10, 50, 100]"
          :current-page="pageProps.pageNum"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
   


    <address-add-dialog ref="addressDialog" @refresh="fetchData"></address-add-dialog>
    
    <address-info-dialog ref="addressInfoDialog" @refresh="fetchData"></address-info-dialog>
    
  </div>
   


</template>

<script>
import { addressList,delAddress } from "@/api/director/address/index";


import addressAddDialog from "@/views/director/work/address/address-add-dialog.vue";
import addressInfoDialog from "@/views/director/work/address/address-info-dialog.vue";

  export default {
    name: "Director-Work-Address",
    components: { addressAddDialog,addressInfoDialog},
    data() {
      return {
       
        searchLoading: false,
        pageProps: {
          records:[],
          total: 0,
          pageSize: 10,
          pageNum: 1
        },

        searchFormData:{
          keyword:"",
          page:0,
          limit:0
        }

      }
    },

    mounted() {
      this.fetchData();
    },



    methods: {

      add(){
        this.$refs.addressDialog.init();
      },

      edit(u_address_id){
        this.$refs.addressInfoDialog.init(u_address_id);
        
      },

      del(row){
        var that=this;
        this.$confirm('确定删除地址?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
            const u_address_id	=row.u_address_id;
            delAddress({u_address_id:u_address_id}).then((response) => {
              console.log(response);
              if(response.code==200){
                that.$message.success("删除成功");
                  that.fetchData();
              }
            });
          
        }).catch(() => {
        
        });
      },

      search(){
        this.fetchData();
      },

      fetchData(){
        var that = this;
        that.searchFormData.page=that.pageProps.pageNum;
        that.searchFormData.limit=that.pageProps.pageSize;

        addressList(that.searchFormData).then((response) => {
          console.log(response);
          if(response.code==200){
            that.pageProps.records = response.data.data;
            that.pageProps.total = response.data.total;
          }else{
            that.$message.error(response.msg?response.msg:"请求错误");
          }
         
        });
      },

       // 当前页变更
      handleCurrentChange(num) {
        this.pageProps.pageNum = num
        this.fetchData()
      },


      // 每页显示页面数变更
      handleSizeChange(size) {
        this.pageProps.pageSize = size
        this.fetchData()
      },
      
    }
  }
</script>

